module.exports = __webpack_public_path__ + "media/img/Rectangle 1685-410bffea.png";